import { types } from "mobx-state-tree";

const FirestoreDate = types.custom({
  name: "FirestoreDate",
  fromSnapshot(value) {
    if (value) {
      if (typeof value.toDate === "function") {
        return value.toDate();
      } else if (typeof value === "string") {
        return new Date(value);
      } else {
        if (
          Object.prototype.toString.call(new Date(value)) === "[object Date]" &&
          !isNaN(new Date(value).getTime())
        ) {
          return new Date(value);
        } else {
          return new Date();
        }
      }
    } else {
      return false;
    }
  },
  toSnapshot(value) {
    return value;
  },
  isTargetType(value) {
    return value instanceof Date;
  },
  getValidationMessage(value) {
    if (value instanceof Object || typeof value === "string") return "";
    else return "geen timestamp";
  }
});

export default FirestoreDate;
